export const ITEM_SIZE = 100;
